export * from './IconAlignLeft';
